var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-divider',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMiniSidebarShown),expression:"!isMiniSidebarShown"}],class:['mb-1', { 'custom-divider': !_vm.isMiniSidebarShown }]})
}
var staticRenderFns = []

export { render, staticRenderFns }